import React, { useRef, useState } from "react";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { useLocation } from "react-router-dom";
import styles from "./Screen3.module.css";
import { BiSolidPlusCircle } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
import addImg from "../../../../assets/wedAddImg.png";
import dots from "../../../../assets/pfdots.png";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { DotsIcon } from "../../../../components/icons/Icons";

// import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
const Screen3 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isModalOpen, setIsModalOpen] = useState(
    WeddingWeb?.wedding_parties?.length > 0 ? false : true
  );
  const [isDetailsModal, setIsDetailsModal] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [img, setImg] = useState();
  const [title, setTitle] = useState("");
  const [id, setId] = useState();
  const [desc, setDesc] = useState("");
  const [detailsArr, setDetailsArr] = useState(
    WeddingWeb?.wedding_parties?.length > 0 ? WeddingWeb?.wedding_parties : []
  );
  const handleInput = useRef();
  const handleImgClick = () => {
    handleInput.current.click();
  };
  // const [editItem, setEditItem] = useState();
  console.log("detailsArrr", detailsArr);
  const dispatch = useDispatch();
  const onClickNext = () => {
    if (detailsArr.length == 0) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please Add atleast one detail",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 3,
          weddingWebId: WeddingWeb?.id,
          detailsArr,
        })
      ).then(() => setCurrentStep((prev) => prev + 1));
    }
  };

  const saveDetails = () => {
    if (!img || !name || !title || !desc) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      let dummyArr = [...detailsArr];
      dummyArr.push({
        // id: detailsArr?.length + 1,
        isNew: true,
        newImage: img,
        name: name,
        title: title,
        description: desc,
      });
      setDetailsArr(dummyArr);
      setIsModalOpen(false);
      setImg();
      setName("");
      setTitle("");
      setDesc("");
      setId();
    }
  };

  const onClickEditBtn = (item, index) => {
    setIsEditModalOpen({ ...item, index });
  };
  const editDetails = () => {
    // let data = {
    //   id: id,
    //   newImage: img,
    //   name: name,
    //   title: title,
    //   description: desc,
    // };
    let index = isEditModalOpen.index;
    setDetailsArr((prev) => {
      prev.splice(index, 1, isEditModalOpen);
      return prev;
    });
    setIsEditModalOpen(false);
    // setImg();
    // setName("");
    // setTitle("");
    // setDesc("");
    // setId();
  };
  const onShowDetails = (item) => {
    setIsDetailsModal(true);
    setId(item?.id);
    setImg(item?.newImage ? item?.newImage : item?.image);
    setName(item?.name);
    setTitle(item?.title);
    setDesc(item?.description);
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <div className={styles.userDetail} onClick={() => onShowDetails(item)}>
          <div className={styles.images}>
            <img
              src={
                item?.newImage
                  ? URL.createObjectURL(item?.newImage)
                  : item?.image
                  ? item?.image
                  : null
              }
              className={styles.pfImg}
            />
            <DotsIcon className={styles.dots} />
          </div>
          <TextComponent text={item?.name} textClass={styles.name} />
          <TextComponent text={item?.title} textClass={styles.role} />
        </div>
        {/* <TextComponent text={item?.title} textClass={styles.title} />
        <TextComponent text={item?.description} textClass={styles.desc} /> */}
        <TextComponent
          text={"Edit"}
          textClass={styles.editBtn}
          onClick={() => onClickEditBtn(item, index)}
        />
        <TextComponent
          text={"Delete"}
          textClass={styles.editBtn}
          onClick={() => {
            setDetailsArr((prev) => {
              let newArr = [...prev];
              newArr.splice(index, 1);
              return newArr;
            });
          }}
        />
      </div>
    );
  };
  return (
    <>
      <div className={styles.content}>
        <div className={styles.textCont}>
          <TextComponent text={"The Wedding Party"} />
        </div>
      </div>
      {detailsArr && (
        <div className={styles.listDiv}>
          <List
            grid={{ lg: 4, xxl: 5, xl: 5, xs: 2, md: 3, sm: 2 }}
            dataSource={detailsArr}
            renderItem={renderItem}
            className={styles.list}
          />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          <BiSolidPlusCircle className={styles.addIcon} />
          <TextComponent text={"Add"} />
        </div>
        <div className={styles.nextBtn}>
          <SubmitButton title={"Next"} onClick={onClickNext} />
        </div>
      </div>

      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          closable={true}
          pinkBg={true}
          // wideModal={true}
          className={styles.modalContent}
        >
          <div className={styles.modalDiv}>
            <div className={styles.upperCon}>
              <div
                className={img ? styles.imageDiv : styles.addImage}
                onClick={handleImgClick}
              >
                <img src={img ? URL.createObjectURL(img) : addImg} />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImg(e.target.files[0])}
                  ref={handleInput}
                  style={{ display: "none" }}
                />
              </div>
              <div className={styles.rightInputs}>
                <InputField
                  placeholder={"Name"}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
                <InputField
                  placeholder={"Title"}
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
              </div>
            </div>

            <TextareaField
              placeholder={"Write Here..."}
              onChange={(e) => setDesc(e.target.value)}
              value={desc}
            />
            <div className={styles.btnDiv}>
              <SubmitButton
                title={"Save"}
                btnClass={styles.saveBtn}
                onClick={saveDetails}
              />
            </div>
          </div>
        </Modal>
      )}
      {isEditModalOpen && (
        <Modal
          isModalOpen={isEditModalOpen}
          setIsModalOpen={setIsEditModalOpen}
          closable={true}
          pinkBg={true}
          onClose={() => {
            setIsEditModalOpen(false);
          }}
          // wideModal={true}
          className={styles.modalContent}
        >
          <div className={styles.modalDiv}>
            <div className={styles.upperCon}>
              <div
                className={
                  !isEditModalOpen?.image && !isEditModalOpen?.newImage?.size
                    ? styles.addImage
                    : styles.imageDiv
                }
                onClick={handleImgClick}
              >
                <img
                  src={
                    isEditModalOpen?.newImage
                      ? URL.createObjectURL(isEditModalOpen?.newImage)
                      : isEditModalOpen?.image
                      ? isEditModalOpen?.image
                      : addImg
                  }
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setIsEditModalOpen({
                      ...isEditModalOpen,
                      newImage: e.target.files[0],
                    })
                  }
                  ref={handleInput}
                  style={{ display: "none" }}
                />
              </div>
              <div className={styles.rightInputs}>
                <InputField
                  placeholder={"Name"}
                  onChange={(e) =>
                    setIsEditModalOpen({
                      ...isEditModalOpen,
                      name: e.target.value,
                    })
                  }
                  value={isEditModalOpen?.name}
                />
                <InputField
                  placeholder={"Title"}
                  onChange={(e) =>
                    setIsEditModalOpen({
                      ...isEditModalOpen,
                      title: e.target.value,
                    })
                  }
                  value={isEditModalOpen?.title}
                />
              </div>
            </div>

            <TextareaField
              placeholder={"Write Here..."}
              onChange={(e) =>
                setIsEditModalOpen({
                  ...isEditModalOpen,
                  description: e.target.value,
                })
              }
              value={isEditModalOpen?.description}
            />
            <div className={styles.btnDiv}>
              <SubmitButton
                title={"Save"}
                btnClass={styles.saveBtn}
                onClick={editDetails}
              />
            </div>
          </div>
        </Modal>
      )}
      {isDetailsModal && (
        <Modal
          isModalOpen={isDetailsModal}
          setIsModalOpen={setIsDetailsModal}
          closable={true}
          // pinkBg={true}
          onClose={() => {
            setId();
            setImg();
            setName("");
            setTitle("");
            setDesc("");
          }}
          // wideModal={true}
          // className={styles.DmodalContent}
        >
          <div className={styles.modalDiv}>
            <div className={styles.DuserDetail}>
              <div className={styles.images}>
                <img
                  src={
                    img?.size ? URL.createObjectURL(img) : img ? img : addImg
                  }
                  className={styles.DpfImg}
                />
                <DotsIcon className={styles.Ddots} />
              </div>
              <TextComponent text={name} textClass={styles.Dname} />
              <TextComponent text={title} textClass={styles.Drole} />
              <TextComponent text={desc} textClass={styles.desc} />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Screen3;
